import { apiClient } from "../config";

async function createLayerForAdmin(payload: any) {
  const res = await apiClient.post(`/admin/geographies`,payload);
  return res.data;
}

export default createLayerForAdmin;
